<template>
  <router-view :key="$route.params.domain"></router-view>
</template>

<script>
export default {
  name: "ResultsRouter",
};
</script>
